import { render, staticRenderFns } from "./WeightLossKnowledge.vue?vue&type=template&id=672b0fb0&scoped=true&"
import script from "./WeightLossKnowledge.vue?vue&type=script&lang=js&"
export * from "./WeightLossKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./WeightLossKnowledge.vue?vue&type=style&index=0&id=672b0fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672b0fb0",
  null
  
)

export default component.exports